import React from "react";

import { BuilderContextProvider } from "../../../Components/GMS/Builder/BuilderContext.jsx";
import BuilderAddEditManage from "../../../Components/GMS/Builder/BuilderAddEditManage.jsx";

function builderAddEdit(props) {
  const { params } = props.match;
  return (
    <React.Fragment>
      <BuilderContextProvider>
        <BuilderAddEditManage builderId={params.id} />
      </BuilderContextProvider>
    </React.Fragment>
  );
}

export default builderAddEdit;
